
<br/>
<div class="sp-gdo-header hidden-xs hidden-sm">
  <div class="col-lg-8 col-lg-offset-2">
    <div class="breadcrumbs ml-5px">
      <a name="route-back"  [routerLink]="'/securehome'" tabindex="1">
        <img alt="home-icon" src="../../../../assets/images/home/ico-default-home-gray.png">
      </a>
      <i style="color: black; margin-left: 10px; margin-right: 10px;" class="fa fa-chevron-right"></i>
     <span style="color: black; cursor: pointer" (keydown.enter)="backButton.click()" #backButton [routerLink]="'/securehome'" tabindex="2">{{homeName}}</span>
      <i style="color: black; margin-left: 10px; margin-right: 10px;" class="fa fa-chevron-right"></i>
      {{deviceName}}
    </div>

  </div>
</div>

<div class="sp-middle-element visible-xs visible-sm">
    <div class="col-xs-12 col-sm-10 col-sm-offset-1 sm-no-padding">
      <div class="row">
        <div class="col-xs-12 sp-back">
          <a name="route-back" (keydown.enter)="backButton.click()" #backButton [routerLink]="'/securehome'"><i class="fa fa-chevron-left"></i>  {{ 'PROFILE.BACK' | translate }}</a>
        </div>
      </div>
    </div>
</div>

<div class="sp-body sp-body-device-detail clearfix">

  <div class="row mt-warning">
    <div class="col-lg-8 col-lg-offset-2 col-xs-12 margin-no-padding">
      <disabled-phone [link]="true" [disabledText]="'HOME.ACCOUNT_DISABLED.PRE'"></disabled-phone>
    </div>
  </div>

  <div *ngIf="errorMessage!=null" class="alert alert-danger alert-dismissible fade in">
    <a class="close" aria-label="close" (click)="errorMessage = null">&times;</a>
    {{ errorMessage }}
  </div>

  <div class="col-sm-12">
    <div *ngIf='gdoDetails'>
      <div class="clearfix sp-gdo-device-info">
        <div class="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
          <h2>{{ 'LOCKS.TITLE' | translate }}</h2>
        </div>
      </div>
      <div class="clearfix sp-gdo-device-detail main-container">
        <div class="col-lg-4 col-lg-offset-2 col-sm-10 col-sm-offset-1 detail-div">
          <div class="clearfix">
            <p class="gdo-detail-key col-xs-5">{{ 'GDO.DETAIL.MODEL' | translate }}</p>
            <p class="gdo-detail-value col-xs-7">{{gdoDetails.rcbModel}}</p>
          </div>
          <div class="clearfix">
            <p class="gdo-detail-key col-xs-5">{{ 'GDO.DETAIL.PRODUCT_FAMILY' | translate }}</p>
            <p class="gdo-detail-value col-xs-7">{{gdoDetails.productFamily}}</p>
          </div>
          <div class="clearfix">
            <p class="gdo-detail-key col-xs-5">{{ 'GDO.DETAIL.SKU' | translate }}</p>
            <p class="gdo-detail-value col-xs-7">{{gdoDetails.sku}}</p>
          </div>
          <div class="clearfix">
            <p class="gdo-detail-key col-xs-5">{{ 'GDO.DETAIL.SERIAL_NUMBER' | translate }}</p>
            <p class="gdo-detail-value col-xs-7">{{gdoDetails.lcuSerialNumber}}</p>
          </div>
          <div class="clearfix">
            <p class="gdo-detail-key col-xs-5">{{ 'GDO.DETAIL.LCU_FIRMWARE' | translate }}</p>
            <p class="gdo-detail-value col-xs-7">{{gdoDetails.lcuFirmware}}</p>
          </div>
          <div class="clearfix">
            <p class="gdo-detail-key col-xs-5">{{ 'GDO.DETAIL.RCB_FIRMWARE' | translate }}</p>
            <p class="gdo-detail-value col-xs-7">{{gdoDetails.firmwareVersion}}</p>
          </div>
          <div class="clearfix">
            <p class="gdo-detail-key col-xs-5">{{ 'GDO.DETAIL.LCU_HARDWARE' | translate }}</p>
            <p class="gdo-detail-value col-xs-7">{{gdoDetails.lcuModel}}</p>
          </div>
          <div class="clearfix">
            <p class="gdo-detail-key col-xs-5">{{ 'GDO.DETAIL.RCB_HARDWARE' | translate }}</p>
            <p class="gdo-detail-value col-xs-7">{{gdoDetails.rcbHardwareRevision}}</p>
          </div>
          <div class="clearfix">
            <p class="gdo-detail-key col-xs-5">{{ 'GDO.DETAIL.MANUFACTURED_DATE' | translate }}</p>
            <p class="gdo-detail-value col-xs-7">{{gdoDetails.manufacturedDate}}</p>
          </div>
          <div class="clearfix">
            <p class="gdo-detail-key col-xs-5">{{ 'GDO.DETAIL.ACTIVATION_DATE' | translate }}</p>
            <p class="gdo-detail-value col-xs-7">{{convertTimestampToDate(gdoDetails.activationDate)}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
